import BaseScreen from './_base';

export default function StrategicViewScreen() {
  return <BaseScreen title="Strategic View" description="Charts and rankings." />;
}
